// rocketStyleActions.js

export const setRocketStyle = (style) => {
    return {
      type: 'SET_ROCKET_STYLE',
      payload: style,
    };
  };
  